import { createAction } from '@reduxjs/toolkit';
import { TChat } from '../../../typescript/redux/chat/types'

const actionSelectChat = createAction('selectChat/success', (value:TChat) => ({
  payload: value,
}));
const actionGetChatById = createAction('getChatById/success', (value:TChat) => ({
  payload: value,
}));

const actionRemoveChat = createAction('deleteChat/success', () => ({
  payload:{}
}));


export {
  actionSelectChat,
  actionGetChatById,
  actionRemoveChat
};
